import { Link } from '~/components'
import { Image } from '~/components/Image'
import { getImageSrc } from '~/helpers'
import RichText from '../../components/RichText/RichText'
import styles from './ProductDetails.module.scss'
import { ProductOverviewProps } from './ProductDetails.types'

const ProductOverview = ({ content, icons }: ProductOverviewProps) => {
  return (
    <div className={styles.productOverview}>
      {icons?.length > 0 && (
        <div className='flex flex-wrap gap-4 pb-10 items-center'>
          {icons.map((icon, index) => {
            return (
              <Link key={index} href={icon.href} className='block relative'>
                <Image
                  src={getImageSrc(icon.src, '200')}
                  width={icon.width}
                  height={icon.height}
                  alt={icon.altText}
                  title={icon.altText}
                />
              </Link>
            )
          })}
        </div>
      )}
      {content && <RichText content={content} />}
    </div>
  )
}

export default ProductOverview
